// export function fileSize(size: number): string {
//     const i = Math.floor(Math.log(size) / Math.log(1024));
//     return (
//         (size / Math.pow(1024, i)).toFixed(2) * 1 +
//         ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
//     );
// }
export function getAppLanguage() {
    var langTag = document.querySelector('meta[name="lang-value"]');
    if (langTag)
        return langTag.content;
    return 'en';
}
export function t(enWord, arWord) {
    var appLang = getAppLanguage();
    if (appLang == 'ar')
        return arWord;
    return enWord;
}
export function currencyInputSuffix(position, currencySymbol) {
    if (position == 'before')
        return undefined;
    return ` ${currencySymbol}`;
}
export function currencyInputPrefix(position, currencySymbol) {
    if (position == 'before')
        return `${currencySymbol} `;
    return undefined;
}
export function currency_format(number, decimals, dec_point, thousands_sep, position, currency, trailing_zeros = false) {
    var value = number_format(number, decimals, dec_point, thousands_sep);
    if (!trailing_zeros) {
        if (position == 'before') {
            return `${currency} ${value.replace(`${dec_point}00`, "")}`;
        }
        return `${value.replace(`${dec_point}00`, "")} ${currency}`;
    }
    if (position == 'before') {
        return `${currency} ${value}`;
    }
    return `${value} ${currency}`;
}
export function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals), sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep, dec = (typeof dec_point === 'undefined') ? '.' : dec_point, s = '', toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
export function swalConfig() {
    return {
        title: "Are you sure?",
        text: "You cannot undo this action!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6473f4",
        cancelButtonColor: "#d93025",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
    };
}
export function swalConfigReset() {
    return {
        title: "Are you sure?",
        text: "You cannot undo this action!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6473f4",
        cancelButtonColor: "#d93025",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
    };
}
export function floatValue(value) {
    if (value == undefined || value == null)
        return 0;
    return Number(parseFloat(value));
}
